import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetReminderItemsDocument,
  GetReminderItemsQueryVariables,
  SortEnumType,
} from '../../types/api/graphql';

export function useReminderItems(variables: GetReminderItemsQueryVariables) {
  const { data: reminderItemsData, loading: reminderItemsLoading } =
    useCacheQuery(GetReminderItemsDocument, {
      variables: {
        ...variables,
        sort: variables.sort ?? [{ nextSendDate: SortEnumType.Asc }],
      },
      skip: !variables.healthProviderId || !variables.group,
    });

  // Subscriptions

  const data = useMemo(() => {
    if (reminderItemsData?.reminders) {
      return {
        ...reminderItemsData.reminders,
        items: reminderItemsData.reminders.items ?? [],
      };
    }

    return null;
  }, [reminderItemsData?.reminders]);

  return {
    data,
    loading: reminderItemsLoading,
  };
}
